import React from "react";

const HomeTgIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2949 0.176566C18.2949 0.176566 20.145 -0.689148 19.9908 1.4133C19.9395 2.27903 19.4769 5.30902 19.1172 8.58639L17.8838 18.2948C17.8838 18.2948 17.781 19.717 16.8559 19.9644C15.9308 20.2117 14.5432 19.0987 14.2862 18.8513C14.0807 18.6658 10.4318 15.8831 9.14695 14.5227C8.78718 14.1517 8.37604 13.4096 9.19833 12.5439L14.5946 6.36028C15.2113 5.61823 15.828 3.8868 13.2584 5.98925L6.06338 11.8638C6.06338 11.8638 5.24109 12.4821 3.69933 11.9256L0.358772 10.6888C0.358772 10.6888 -0.874661 9.76131 1.23245 8.83371C6.37176 5.92737 12.6931 2.9592 18.2949 0.176566Z"
        fill="#C6B7FF"
      />
    </svg>
  );
};

export default HomeTgIcon;
